import React from "react";

import { useNavigate, useLocation } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import { FaTimes } from "react-icons/fa";

const ViewCareerDetails = ({ show, handleClose }) => {
  const location = useLocation();
  const blogData = location.state?.blogProbsData || {};
  const navigate = useNavigate();

  return (
    <div className="modal-overlay event_and_blog admin_modal_preview ">
      <div className="custom-modal-content">
        <h2>View Blog</h2>
        <div className="custom-form-group closepreview text-right">
          <button
            type="button"
            className="custom-btn-cancel"
            onClick={() => navigate("/blog-news")}
          >
            <FaTimes />
          </button>
        </div>
        <form className="m-0">
          <div className="custom-form-group d-flex">
            <label className="custom-label">Image</label>
            <span>:</span>
            <div className="preview_img_wrap">
              <div className="uploadimgsect">
                <div className="modal_preview_img">
                  <img
                    className=""
                    src={blogData.imagePath}
                    alt="Preview"
                    width="200"
                    style={{ marginBottom: "10px" }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="custom-form-group eb_title">
            <label className="custom-label">Title</label>
            <span>:</span>
            <h5>{blogData.title}</h5>
          </div>

          <div className="custom-form-group description_limit">
            <label className="custom-label">Description</label>
            <span>:</span>
            <p style={{ color: "black", margin: "5px 0" }}>
              {blogData.description}
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ViewCareerDetails;
